import script from "./CreateMemoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateMemoPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateMemoPage.vue?vue&type=style&index=0&id=65314a0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65314a0f"]])

export default __exports__